import { render, staticRenderFns } from "./InformationModal.vue?vue&type=template&id=6efb2f94&scoped=true"
import script from "./InformationModal.vue?vue&type=script&lang=js"
export * from "./InformationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efb2f94",
  null
  
)

export default component.exports